export default __webpack_public_path__ + "static/kitchenvalley-ksbi-b76bb9feb59e944675c76c80e9338c58.png";